import { ProfileFormField } from './ProfileFormField';

export function EstateContextFields() {
  return (
    <>
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="estate_jurisdiction"
        label="Estate jurisdiction"
      />
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="capacity_status"
        label="Mental capacity"
      />
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="capacity_basis"
        label="How capacity is known"
      />
    </>
  );
}

export function WillDetailFields() {
  return (
    <>
      <ProfileFormField entityType="EstatePlanning" fieldName="will_status" label="Will status" />
      <ProfileFormField entityType="EstatePlanning" fieldName="will_type" label="Will type" />
      <ProfileFormField entityType="EstatePlanning" fieldName="will_date" label="Will date" />
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="last_reviewed_will"
        label="When did you last review your will?"
      />
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="will_location"
        label="Where is the will kept?"
      />
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="has_codicil"
        label="Has a codicil?"
      />
      <ProfileFormField entityType="EstatePlanning" fieldName="executor_names" label="Executors" />
      <ProfileFormField
        entityType="EstatePlanning"
        fieldName="appoints_child_guardians"
        label="Appoints guardians for children?"
      />
      <ProfileFormField entityType="EstatePlanning" fieldName="will_notes" label="Will notes" />
    </>
  );
}
